// The lineage page is appended before the first signature, so it only exists
// for the "sign now, by myself" flow. Any other signer in the picture means the
// document goes through the multi-signer path, where appending a page would
// invalidate an earlier signature (note #6, §8.4). The server gate refuses it
// too; this just keeps the option off the screen.

// Label the annotator gives the current user in the signer panel.
const CURRENT_USER_LABEL = 'Yo';

export type LineageToggleVisibilityInput = {
	// 'add-signer' is the request-signature flow: never offer the toggle there.
	mode: 'create' | 'add-signer';
	currentUserEmail: string | null;
	// Emails of the signers listed in the placement panel.
	signerEmails: string[];
	// Emails the placed annotations are assigned to.
	annotationEmails: string[];
};

function isSomeoneElse(email: string, currentUserEmail: string): boolean {
	return email !== currentUserEmail && email !== CURRENT_USER_LABEL;
}

export function shouldShowLineageToggle({
	mode,
	currentUserEmail,
	signerEmails,
	annotationEmails,
}: LineageToggleVisibilityInput): boolean {
	if (mode !== 'create') {
		return false;
	}

	// Without a known signer identity we cannot tell our own entries from
	// someone else's, so stay hidden.
	if (!currentUserEmail) {
		return false;
	}

	return ![...signerEmails, ...annotationEmails].some((email) =>
		isSomeoneElse(email, currentUserEmail),
	);
}
